module.exports = __webpack_public_path__ + "static/media/test7_4.005e5f4f.png";